/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapWest = createReactComponent("map-west", "IconMapWest", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 9l1 6l2 -3.75l2 3.75l1 -6", key: "svg-1" }]
]);

export { IconMapWest as default };
//# sourceMappingURL=IconMapWest.js.map
